import { render } from "./CardAction.vue?vue&type=template&id=2297349b&scoped=true&ts=true"
import script from "./CardAction.vue?vue&type=script&lang=ts"
export * from "./CardAction.vue?vue&type=script&lang=ts"

import "./CardAction.vue?vue&type=style&index=0&id=2297349b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2297349b"]])

export default __exports__